import { render, staticRenderFns } from "./AccountTransactionAdd.vue?vue&type=template&id=fb2c6b44&"
import script from "./AccountTransactionAdd.vue?vue&type=script&lang=js&"
export * from "./AccountTransactionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports